import { render, staticRenderFns } from "./JenisPermohonan.vue?vue&type=template&id=d3d68da0&"
import script from "./JenisPermohonan.vue?vue&type=script&lang=js&"
export * from "./JenisPermohonan.vue?vue&type=script&lang=js&"
import style0 from "./JenisPermohonan.vue?vue&type=style&index=0&id=d3d68da0&prod&lang=css&"
import style1 from "./JenisPermohonan.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports